import PropTypes from 'prop-types'
import { Button, Popconfirm } from 'antd'
import {
  CheckCircleTwoTone,
  DeleteOutlined,
  EditOutlined,
} from '@ant-design/icons'
import { Link } from 'react-router-dom'
import { createUseStyles } from 'react-jss'
import { toPath } from '../../routes'

const useStyles = createUseStyles({
  card: {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
  },
  name: {
    fontWeight: 600,
    fontSize: 15,
    minWidth: 0,
    overflowWrap: 'anywhere',
  },
  line: {
    fontSize: 13,
    color: '#595959',
    overflowWrap: 'anywhere',
  },
  // No color here: CheckCircleTwoTone carries its own `twoToneColor`, matching
  // the desktop column.
  lineIcon: {
    marginRight: 6,
  },
  actionsLine: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: 14,
    marginTop: 4,
  },
})

// Every desktop column fits on the card, so these rows need no expand toggle.
export default function DeviceModelMobileCard({ deviceModel, onDelete }) {
  const classes = useStyles()
  const { icmCapable, id, manufacturer, name } = deviceModel

  return (
    <div className={classes.card}>
      <div className={classes.name}>{name || '—'}</div>
      <div className={classes.line}>{manufacturer || '—'}</div>
      {/* Like the desktop column, nothing is shown when the model is not ICM capable. */}
      {icmCapable && (
        <div className={classes.line}>
          <CheckCircleTwoTone
            twoToneColor="#52c41a"
            className={classes.lineIcon}
          />
          ICM capable
        </div>
      )}
      <div className={classes.actionsLine}>
        <Link
          to={toPath.deviceModels.deviceModel.edit({ id })}
          className="edit-button"
        >
          <Button
            type="link"
            size="small"
            icon={<EditOutlined />}
            style={{ paddingLeft: 0 }}
          >
            Edit
          </Button>
        </Link>
        <Popconfirm
          title="Are you sure you want to deactivate this device model?"
          onConfirm={() => onDelete(id)}
          okText="Yes"
          cancelText="No"
          placement="topRight"
        >
          <Button
            type="link"
            size="small"
            icon={<DeleteOutlined />}
            className="delete-button"
            style={{ paddingLeft: 0 }}
          >
            Deactivate
          </Button>
        </Popconfirm>
      </div>
    </div>
  )
}

DeviceModelMobileCard.propTypes = {
  deviceModel: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string,
    manufacturer: PropTypes.string,
    icmCapable: PropTypes.bool,
  }).isRequired,
  onDelete: PropTypes.func.isRequired,
}
